import api from './api';

const getConfigDac = () => {
  return api.get(
    `parameter/v1/parameter/get-config/after.deploy.dac.date`,
    {},
    false,
    false,
    false
  );
};

export default {
  getConfigDac,
};
